import { useTranslate } from 'core/hooks/useTranslate';
import { useUser } from 'core/lite/hooks/useUser';
import { useState } from 'react';

export function useDialogReassign({ onSuccess }) {
  const { t } = useTranslate();
  const { user } = useUser();

  const [comment, setComment] = useState('');

  function onChangeComment(e) {
    setComment(e.currentTarget.value);
  }

  function onReassign() {
    onSuccess(comment);
    setComment('');
  }

  return { t, user, comment, onChangeComment, onReassign };
}
